module.exports = __webpack_public_path__ + "img/ball.f145155a.png";